export function initGoogleMaps() {
    if (window.acf) {
        window.acf.addAction(
            'render_block_preview/type=google-maps',
            googleMaps
        );
    }
}

export function googleMaps() {
    loadJS(
        '//maps.googleapis.com/maps/api/js?key=AIzaSyAGPOGs9WoR0VxzbMRjSe6Pt947QRGtdhA&callback=GoogleMapsLetsGo',
        false,
        () => {}
    );

    window.GoogleMapsLetsGo = () => {
        let maps = document.querySelectorAll('.acf-map');
        [...maps].forEach((v, i, a) => {
            var map = initMap(v);
        });
    };

    function initMap(el) {
        // Find marker elements within map.
        let markers = el.querySelectorAll('.marker');
        let zoom = el.dataset.zoom || 16;

        // Create gerenic map.
        var mapArgs = {
            zoom: zoom,
            mapTypeId: google.maps.MapTypeId.ROADMAP,
        };
        var map = new google.maps.Map(el, mapArgs);

        // Add markers.
        map.markers = [];
        let infoWindows = [];
        [...markers].forEach((v, i, a) => {
            initMarker(v, map, infoWindows);
        });

        // Center map based on markers.
        centerMap(map);

        // Return map instance.
        return map;
    }

    function initMarker(marker, map, infoWindows) {
        // Get position from marker.
        var lat = marker.dataset.lat;
        var lng = marker.dataset.lng;
        var latLng = {
            lat: parseFloat(lat),
            lng: parseFloat(lng),
        };

        const geocoder = new google.maps.Geocoder();
        const infowindow = new google.maps.InfoWindow({
            maxWidth: 350,
        });

        geocoder
            .geocode({ placeId: marker.dataset.place })
            .then(({ results }) => {
                if (results[0]) {
                    if (marker.dataset.page) {
                        infowindow.setContent(
                            '<div id="content">' +
                                '<h1 id="firstHeading" class="firstHeading text-blue text-base font-bold">Grundon ' + marker.dataset.name + '</h1>' +
                                results[0].formatted_address +
                                '<p class="mt-2">For more information, <a href="' +
                                marker.dataset.page +
                                '" class="text-blue underline">click here.</a></p>' +
                                '</div>'
                        );
                    } else {
                        infowindow.setContent(
                            '<div id="content">' +
                                '<h1 id="firstHeading" class="firstHeading text-blue text-base font-bold">Grundon Waste Management</h1>' +
                                results[0].formatted_address +
                                '</div>'
                        );
                    }
                    infowindow.open(map, marker);
                } else {
                    console.log('No results found');
                }
            })
            .catch((e) => console.log('Geocoder failed due to: ' + e));

        // Create marker instance.
        var marker_instance = new google.maps.Marker({
            position: latLng,
            map: map,
        });

        infoWindows.push(infowindow);

        // Append to reference for later use.
        map.markers.push(marker_instance);

        marker_instance.addListener('click', () => {
            for (var i = 0; i < infoWindows.length; i++) {
                infoWindows[i].close();
            }
            infowindow.open({
                anchor: marker_instance,
                map,
            });
        });
    }
    function centerMap(map) {
        // Create map boundaries from all map markers.
        var bounds = new google.maps.LatLngBounds();
        map.markers.forEach(function (marker) {
            bounds.extend({
                lat: marker.position.lat(),
                lng: marker.position.lng(),
            });
        });

        // Case: Single marker.
        if (map.markers.length == 1) {
            map.setCenter(bounds.getCenter());

            // Case: Multiple markers.
        } else {
            map.fitBounds(bounds);
        }
    }

    function loadJS(FILE_URL, async = true, callback) {
        let scriptEle = document.createElement('script');
        scriptEle.setAttribute('src', FILE_URL);
        scriptEle.setAttribute('type', 'text/javascript');
        scriptEle.setAttribute('async', async);
        document.body.appendChild(scriptEle);
        scriptEle.addEventListener('load', () => {
            callback();
        });
    }
}
